'use client';

import { memo } from 'react';

import Link from 'next/link';

import ImageAsset from '@/components/elements/image-asset';
import { Partner } from '@/types/partners';

interface Props {
    partners: Partner[];
}

export function PartnerCarousel(props: Props) {
    return (
        <div className="flex w-max animate-scroll">
            {props.partners.concat(props.partners).map((partner: Partner, index) => (
                <div
                    key={`${partner.id}-${index}`} // Use unique keys
                    className="border-1 flex w-60 flex-col items-center justify-start gap-x-4 rounded-full p-1"
                >
                    {Boolean(partner.ext_link) ? (
                        <>
                            <Link
                                className="relative h-28 w-28 rounded-full border-4 border-accent border-y-amber-400"
                                href={partner.ext_link ?? ''}
                                target={'_blank'}
                            >
                                <ImageAsset
                                    ids={[partner.image_logo]}
                                    assetKey="partnerLogo"
                                    objectFit="cover"
                                    priority
                                    className="h-3 w-20 rounded-full p-1 grayscale"
                                />
                            </Link>
                            <span className="mt-4 w-full text-center text-base">{partner.name}</span>
                        </>
                    ) : (
                        <>
                            <div className="relative h-28 w-28 rounded-full border-4 border-accent border-y-amber-400">
                                <ImageAsset
                                    ids={[partner.image_logo]}
                                    assetKey="partnerLogo"
                                    objectFit="cover"
                                    priority
                                    className="h-3 w-20 rounded-full p-1 grayscale"
                                />
                            </div>
                            <span className="mt-4 w-full text-center text-base">{partner.name}</span>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
}

export default memo(PartnerCarousel);
